<template>
  <div class="mnd-tariffline" :class="{'mnd-tariffline_bold': bold}">
    <div class="mnd-tariffline__left">
      <div class="mnd-tariffline__name">
        <slot name="left"></slot>
      </div>
    </div>
    <div class="mnd-tariffline__price">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bold: { type: Boolean, default: false }
  }
}
</script>

<style lang="sass">
.mnd-tariffline
  display: flex
  align-items: flex-start
  padding: 18.2px 0
  border-bottom: 1px solid colors.$anothersilver
  &_bold &__name
    font-weight: 500
  &__left
    width: calc(100% - 200px)
    margin-right: 16px
    @include for-mob
      width: 100%
      margin-right: 0

  &__name
    width: fit-content
    color: colors.$gray5
    max-width: 800px
    line-height: 1.28
  &__price
    line-height: 1.28
    max-width: 184px
    font-weight: 500
    letter-spacing: globalvars.$onespacing
    color: colors.$gray3
  @include for-mob
    display: block
    padding: 11px 0 8px
    &__name
      font-size: 13px
      line-height: 13px
      margin-bottom: 10px
      margin-right: -5px
      width: calc(100% + 5px)
    &__price
      font-size: 13px
      line-height: 18px
      max-width: 100%
      &:empty
        display: none

</style>